module.exports = __webpack_public_path__ + "img/creditCard.1068b9ea.svg";